import {
  COOLDOWN_SET_FILTERS,
  COOLDOWN_CLEAR_FILTERS,
  COOLDOWN_SET_PAGE,
  COOLDOWN_SET_PAGE_SIZE,
  COOLDOWN_SET_SEARCH,
  COOLDOWN_SET_SORT,
  COOLDOWN_FETCH_REQUEST,
  COOLDOWN_FETCH_SUCCESS,
  COOLDOWN_FETCH_FAILURE,
} from '../actions/actionTypes';
import { CooldownAction } from '../actions/cooldownActions';
import { FiltersState, EMPTY_FILTERS } from '../../Talent/components/FiltersDrawer';
import { RawTalentRow } from '../../Talent/transformers/talentTransformer';

export interface CooldownState {
  filters: FiltersState;
  search: string;
  sort: { column: string; direction: string } | null;
  data: RawTalentRow[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
  loading: boolean;
  error: string | null;
}

const initialState: CooldownState = {
  filters: EMPTY_FILTERS,
  search: '',
  sort: null,
  data: [],
  pagination: { page: 1, pageSize: 20, total: 0, totalPages: 0 },
  loading: false,
  error: null,
};

export default function cooldownReducer(
  state: CooldownState = initialState,
  action: CooldownAction,
): CooldownState {
  switch (action.type) {
    case COOLDOWN_SET_FILTERS:
      return { ...state, filters: action.payload, pagination: { ...state.pagination, page: 1 } };
    case COOLDOWN_CLEAR_FILTERS:
      return { ...state, filters: EMPTY_FILTERS, pagination: { ...state.pagination, page: 1 } };
    case COOLDOWN_SET_SEARCH:
      return { ...state, search: action.payload, pagination: { ...state.pagination, page: 1 } };
    case COOLDOWN_SET_SORT:
      return { ...state, sort: action.payload, pagination: { ...state.pagination, page: 1 } };
    case COOLDOWN_SET_PAGE:
      return { ...state, pagination: { ...state.pagination, page: action.payload } };
    case COOLDOWN_SET_PAGE_SIZE:
      return { ...state, pagination: { ...state.pagination, pageSize: action.payload, page: 1 } };
    case COOLDOWN_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case COOLDOWN_FETCH_SUCCESS:
      return { ...state, loading: false, data: action.payload.data, pagination: action.payload.pagination };
    case COOLDOWN_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
